import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { TToast, TToasterPosition, TUnionToastDirection } from '@r1-frontend/ui-react/experimental/Toaster/types';

import Toast from './Toast';

export type TToasterProps = {
    $verticalIndent: number,
    $horizontalIndent: number,

    toasts: Omit<TToast, 'direction'>[],
    removeToastHandler: (id: string) => void,
    className?: string,
} & TUnionToastDirection

const Toaster = (
    {
        direction,
        toasts,
        removeToastHandler,

        ...props
    }: TToasterProps,
): JSX.Element => {
    const _toasts = Object.values(toasts);

    return <div {...props} className={`${props.className} ${_toasts.length > 0 ? 'active' : 'passive'}`}>
        {_toasts.map((toast: Omit<TToast, 'direction'>) => {
            return <Toast
                key={`Toaster_Toast_${toast.id}`}
                id={toast.id}
                direction={direction}
                permanent={toast.permanent}
                removeHandler={removeToastHandler}
            >
                {toast.children}
            </Toast>;
        })}
    </div>;
};

export const StyledToaster = styled(Toaster) <{ position: TToasterPosition, $horizontalIndent: number, $verticalIndent: number }>`
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    flex-wrap: wrap;
    gap: 1vh;
    width: auto;
    position: fixed;

    &.active {
       z-index: 11000;
    }
    
    &.passive {
        z-index: -1;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        padding-right: 20px;
        padding-left: 20px;
    }

    ${({ position, $horizontalIndent = 10, $verticalIndent = 10 }) => {
        const result = [];
        if (position.includes('l')) {
            result.push(`padding-left: ${$horizontalIndent}px`);
            result.push('left: 0');
        }
        if (position.includes('r')) {
            result.push(`padding-right: ${$horizontalIndent}px`);
            result.push('right: 0;');
        }
        if (position.includes('t')) {
            result.push(`padding-block-start: ${$verticalIndent}px`);
            result.push('inset-block-start: 0');
            result.push('top: 0');
            result.push('flex-direction: column-reverse');
        }

        if (position.includes('b')) {
            result.push(`padding-block-end: ${$verticalIndent}px`);
            result.push('inset-block-end: 0');
            result.push('bottom: 0');
        }

        if (position.includes('c')) {
            result.push('width: 100%');
            result.push('justify-content: center');
        }

        return css`
            ${result.join(';')}
        `;
    }}
`;

export default StyledToaster;
